import { AngularFireAnalytics } from '@angular/fire/analytics';
import { AnalyticsService } from './services/analytics/analytics.service';
import { environment } from './../environments/environment';
import { ErrorMonitoringService } from 'src/app/services/error-monitoring/error-monitoring.service';
import { LoginPage } from './pages/login/login.page';
import { ModalController } from '@ionic/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserDataService } from './services/user-data/user-data.service';
import { OpenModalGuardService } from './services/open-modal-guard/open-modal-guard.service';
import { HelperService } from './services/helper/helper.service';
import { SwUpdate } from '@angular/service-worker';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as moment from 'moment-timezone';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { CustomAlertComponent } from './components/custom-alert/custom-alert.component';
import { DebtorGuardService } from './services/debtor-guard/debtor-guard.service';
declare var gtag: any;
declare var fbq: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  user = null;
  userSubscriptionState: Subscription;
  dynamicYear = new Date().getFullYear();
  appVersion = environment.version;
  referral: string;
  environment = environment;
  public appPages = [
    {
      title: 'Mediagenda',
      url: '/',
      icon: '/assets/imgs/icons/mediagenda-active.svg',
      auth: false
    },
    {
      title: 'Grupo Familiar',
      url: '/beneficiarios',
      icon: '/assets/imgs/icons/beneficiarios.svg',
      auth: true
    },
    {
      title: 'Billetera',
      url: '/billetera',
      icon: '/assets/imgs/icons/billetera-active.svg',
      auth: true
    }
  ];

  constructor(
    private userDataService: UserDataService,
    private openModalGuardService: OpenModalGuardService,
    private modalController: ModalController,
    private errorMonitoringService: ErrorMonitoringService,
    public helperService: HelperService,
    private swUpdate: SwUpdate,
    private router: Router,
    private analytics: AnalyticsService,
    private afMessaging: AngularFireMessaging,
    private debtorGuardService: DebtorGuardService,
    private firebaseAnalytics: AngularFireAnalytics,
    private route: ActivatedRoute
  ) {
    // Suscripción cambios de ruta si es production
    if (environment.production && !environment.test) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.firebaseAnalytics.setCurrentScreen(event.url);
          // analytics
          gtag('config', environment.googleAnalyticsTrackingCode, {
            page_title: event.url,
            page_path: event.url
          });
          // facebook
          fbq('track', 'PageView');
        }
      });
    }
    // agrega el valor del referido a local storage
    this.route.queryParams.subscribe( params => {
      // obtiene el parametro referral
      this.referral = params['referral'];
      if (this.referral && typeof(Storage) !== 'undefined') {
        localStorage.referralCode = this.referral;
      }
    });
    /* Suscripción Datos Usuario */
    this.userSubscriptionState = this.userDataService.userStateObservable.subscribe(user => {
      this.user = user;
      if (this.user && this.user.uid) {
        if (!this.user.referred && typeof(Storage) !== 'undefined') {
          const code = localStorage.referralCode;
          if (code) {
            // actualiza el perfil
            this.userDataService.updateProfile({
              referred: code
            }, this.user.uid).catch(error => {
              this.errorMonitoringService.sendError(error, 'updateProfile - App Component');
            });
          }
        }
        // valida si tiene token para messaging
        this.afMessaging.getToken.subscribe(token => {
          if (token) {
            this.saveTokenToUser(token);
          } else {
            this.showNotificationsPermission();
          }
        }, (error) => {
          console.error('Error obteniendo token', error);
        });
        // envia el userID a google analytics
        if (environment.production && !environment.test) {
          gtag('config', environment.googleAnalyticsTrackingCode, {
            user_id: this.user.uid
          });
        }
        // envia el contexto a sentry
        this.errorMonitoringService.setUserContext(this.user);
        // si no tiene registrado el objeto de tipo servicios
        if (this.user.services === undefined) {
          // states active, blocked
          const userTypes: any = {
            services: {
              state: 'active',
              stateChanges: [{
                changeFrom: 'lead',
                changeTo: 'active',
                date: moment().tz('America/Bogota').format()
              }]
            }
          };
          // actualiza el perfil
          this.userDataService.updateProfile(userTypes, this.user.uid).catch(error => {
            this.errorMonitoringService.sendError(error, 'updateProfile - App Component');
          });
        }

        // valida si es deudor moroso
        this.debtorGuardService.validateDebtor(this.user.uid);
      } else {
        this.errorMonitoringService.setUserContext(null);
      }
    }, error => {
      this.errorMonitoringService.sendError(error, 'getUser');
      this.helperService.presentMessageAlert('Mensaje', 'No pudimos obtener tu usuario, inténtalo de nuevo');
    });
  }

  ngOnInit(): void {
    // quita el comportamiento de install app por default
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 76 and later from showing the mini-infobar
      e.preventDefault();
    });
    /* Verifica si hay nuevas versiones de la app y notifica al usuario para que recargue la página */
    if (this.swUpdate.isEnabled) {

      this.swUpdate.available.subscribe(() => {

        this.openUpdateApp();

      });
    }
    // escucha los nuevos mensajes si el usuario esta activo en la app
    this.afMessaging.messages.subscribe((message: any) => {
      this.helperService.presentMessageAlert(
        message.notification.title,
        message.notification.body,
        '',
        'notificaciones',
        'medium'
      );

    }, (error) => {
      console.error('Error escuchando mensajes', error);
    });
  }

  // Valida si puede estar en el menu
  validateMenu(p): boolean {
    if (p.title === 'ingresar' && this.user && !this.user.isAnonymous) {
      return false;
    }
    if (p.auth && !this.user) {
      return false;
    }
    if (p.auth && this.user && this.user.isAnonymous) {
      return false;
    }
    return true;
  }

  // determina si es mediamigo o no
  isMedifriend() {
    if (
      this.user &&
      (
        this.user.tramitesMedifriend || this.user.acompanamientoMedifriend ||
        this.user.telemedicinaMedifriend
      )
    ) {
      return true;
    }
    return false;
  }

  // determina si es vendedor o no
  isSeller() {
    if (this.user && this.user.referralCode) {
      return true;
    }
    return false;
  }

  // Open login
  async openLogin() {
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);
    // crea el modal con el mapa
    const loginModal = await this.modalController.create({
      component: LoginPage,
      componentProps: {
        actionMessage: '',
        openLogin: true
      },
      backdropDismiss: false
    });
    loginModal.onDidDismiss().then(data => {
      // indica que se debe bloquear/desbloquear la navegacion
      this.openModalGuardService.setModalOpen(false);
    });
    // presenta el modal con el login
    return await loginModal.present();
  }

  // registra el evento en GA
  registerEvent(category: string, action: string, label = '') {
    this.analytics.registerGoogleAnalyticsEvent(action, {
      event_category: category,
      event_label: label
    });
  }

  // save the permission token in firestore
  saveTokenToUser(token: string): void {
    const currentTokens = this.user.fcmTokens || [];
    // If token does not exist in firestore, update db
    if (!currentTokens.includes(token)) {
      currentTokens.push(token);
      const updateData = {
        fcmTokens: currentTokens
      };
      this.userDataService.updateProfile(updateData, this.user.uid);
    }
  }

  async showNotificationsPermission() {
    this.openModalGuardService.setModalOpen(true);
    const notificationModal = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-small',
      componentProps: {
        icon: 'notificaciones',
        title: 'Activa nuestras notificaciones',
        subtitle: '',
        message: 'Para que estés siempre actualizado Medilabb quiere activar las notificaciones en tu dispositivo',
        buttons: [
          {
            text: 'Activar',
            fill: 'solid',
            color: 'primary',
            action: 'active'
          },
        ]
      },
      backdropDismiss: false
    });

    notificationModal.onDidDismiss().then(data => {

      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'active') {
        this.afMessaging.requestToken.subscribe(token => {
          this.saveTokenToUser(token);
        }, (error) => {
          console.error('Error obteniendo token', error);
          this.helperService.presentMessageAlert(
            '¡Ocurrió un error!',
            'No se pudieron activar las notificaciones, inténtalo de nuevo',
            '',
            'alerta',
            'medium'
          );
        });
      }
    });
    return await notificationModal.present();
  }

  async openUpdateApp() {
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);
    // crea el modal con el mapa
    const openModal = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-small',
      componentProps: {
        icon: 'nueva-version',
        title: 'Tenemos una nueva versión',
        subtitle: '',
        message: 'Trabajamos para mejorar tu experiencia, conoce la nueva versión de nuestra aplicación',
        buttons: [
          {
            text: 'Actualizar',
            fill: 'solid',
            color: 'primary',
            action: 'install'
          },
        ]
      },
      backdropDismiss: false
    });
    openModal.onDidDismiss().then(data => {
      // indica que se debe bloquear/desbloquear la navegacion
      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'install') {
        window.location.reload();
      }
    });
    // presenta el modal con el login
    return await openModal.present();
  }

  // abre un link externo
  openLink(link: string, event: string) {
    this.firebaseAnalytics.logEvent(event);
    window.open(link, 'blank');
  }

  // on destroy
  ngOnDestroy(): void {
    if (this.userSubscriptionState) {
      this.userSubscriptionState.unsubscribe();
    }
  }

}
